import { TDevice } from '@cian/utils';

export const getSiteType = (deviceType: TDevice | undefined) => {
  return deviceType === 'phone' ? 'mobile' : deviceType;
};
